import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@client/components/admin/shared';
import { PostsList } from '@client/components/admin/posts-list';

export const Route = createFileRoute('/admin/updates')({ component: UpdatesPage });

/** All Investor Updates across rooms (SPEC §6): write once, publish to one or more rooms or to every investor. */
function UpdatesPage() {
  return (
    <>
      <PageHeader title="Investor updates" eyebrow="Updates" />
      <PostsList className="px-6 py-6 md:px-8" />
    </>
  );
}
